module.exports = __webpack_public_path__ + "static/media/contact.79a90aaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact.jpg
// module id = 582
// module chunks = 0